import { ContentPage } from 'components';
import { useContext } from 'react';
import { PageContext } from '../context/PageContext';

export const pages = {
	StartPage: ContentPage,
	ContentPage: ContentPage,
};

export const PageType: React.FC<PageModel> = () => {
	const pageContext = useContext(PageContext);
	const pageType = pageContext.pageType as keyof typeof pages;

	if (typeof pages[pageType] === 'undefined') {
		return <div>{`Page type [${pageType}] is missing a React Component. Check /components/Page.tsx`}</div>;
	}

	const DynamicPageTemplate = pages[pageType];

	return <DynamicPageTemplate />;
};
